/**
 * Created by dreamc_t on 2017/3/28.
 */

var containParams = function (orginObj, newObj) {
    var o = {};
    for (var key in orginObj) {
        o[key] = key in newObj ? newObj[key] : orginObj[key];
    }


    return o;
};

var containVarParams =function (orginObj, newObj) {
    var o = {};
    for (var key in orginObj) {
        o[key] = key in newObj ? newObj[key] : orginObj[key];
    }
    for (var key in newObj) {
        o[key] =  newObj[key] ;
    }
    return o;
};


var filterParams = function (keys, obj) {
    var o = {};
    var key;

    for (var i = 0, iLen = keys.length; i < iLen; i++) {
        key = keys[i];

        if (key in obj) {
            o[key] = obj[key];
        }
    }

    return o;
};

var getStarTime = function () {
    return 0;
};

var getFrom = function () {
    var from = '',
        url = window.location.href;
    var startIndex = url.indexOf('http://') + 'http://'.length,
        endIndex = url.indexOf('.ifeng.com');

    if (startIndex !== -1 && endIndex !== -1) {
        from = url.substr(startIndex, (endIndex - startIndex));
        return from;
    }

    return from;
};
//获取cookie

var getCookie = function (name) {
    var arg = name + "=";
    var alen = arg.length;
    var clen = document.cookie.length;
    var i = 0;

    while (i < clen) {
        var j = i + alen;
        if (document.cookie.substring(i, j) === arg) {
            return (function (offset) {
                var endstr = document.cookie.indexOf(";", offset);

                if (endstr === -1) {
                    endstr = document.cookie.length;
                }

                return decodeURIComponent(document.cookie.substring(offset, endstr));
            })(j);
        }

        i = document.cookie.indexOf(" ", i) + 1;

        if (i === 0) {
            break;
        }
    }

    return "";
};

var setCookie = function (name, value, params) {
    var cStrArr = [];
    cStrArr.push(name + '=' + encodeURIComponent(value));

    if (typeof params === 'undefined') {
        params = {};
    }
    if (typeof params.expires !== 'undefined') {
        var date = new Date();
        date.setTime(date.getTime() + (params.expires) * 1000 * 60);
        cStrArr.push('; expires=' + date.toGMTString());
    }
    cStrArr.push((typeof params.path !== 'undefined') ? '; path=' + params.path : '');
    cStrArr.push((typeof params.domain !== 'undefined') ? '; domain=' + params.domain : '');
    cStrArr.push((typeof params.secure !== 'undefined') ? '; secure' : '');

    document.cookie = cStrArr.join('');
};

var _merge = function(s, t) {
    var result = {};

    if (!t) {
        return result;
    }

    for (var i in s) {
        result[i] = typeof t[i] !== "undefined" ? t[i] : s[i];
    }

    return result;
};



//随机获取一个uid
var  getRandomUid = function() {
    var date = new Date().getTime(),
        uid = '',
        fn = '',
        sn = '';

    fn = ((Math.random() * 2147483648) | 0).toString(36);
    sn = Math.round(Math.random() * 10000);
    uid = date + '_' + fn + sn;
    return uid;
};
var doc = document;
var win = window;

var device = {type : "pc"};

var detect = function (ua) {

    var oTemp = {};
    var os = oTemp.os = {};
    var browser = oTemp.browser = {};
    var webkit = ua.match(/WebKit\/([\d.]+)/);
    var android = ua.match(/(Android)\s+([\d.]+)/);
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var iphone = !ipad && ua.match(/(iPhone\sOS)\s([\d_]+)/);
    var webos = ua.match(/(webOS|hpwOS)[\s\/]([\d.]+)/);
    var touchpad = webos && ua.match(/TouchPad/);
    var kindle = ua.match(/Kindle\/([\d.]+)/);
    var silk = ua.match(/Silk\/([\d._]+)/);
    var blackberry = ua.match(/(BlackBerry).*Version\/([\d.]+)/);
    var bb10 = ua.match(/(BB10).*Version\/([\d.]+)/);
    var rimtabletos = ua.match(/(RIM\sTablet\sOS)\s([\d.]+)/);
    var playbook = ua.match(/PlayBook/);
    var chrome = ua.match(/Chrome\/([\d.]+)/) || ua.match(/CriOS\/([\d.]+)/);
    var firefox = ua.match(/Firefox\/([\d.]+)/);
    var bIsWM = ua.match(/Windows Phone/);

    // Todo: clean this up with a better OS/browser seperation:
    // - discern (more) between multiple browsers on android
    // - decide if kindle fire in silk mode is android or not
    // - Firefox on Android doesn't specify the Android version
    // - possibly devide in os, device and browser hashes

    browser.webkit = !!webkit;

    if (browser.webkit) {
        browser.version = webkit[1];
    }

    // æ˜¯å¦æ˜¯windows phone
    if (bIsWM) {
        os.wphone = true;
    }

    if (android) {
        os.android = true;
        os.version = android[2];
    }

    if (iphone) {
        os.ios = true;
        os.iphone = true;
        os.version = iphone[2].replace(/_/g, '.');
    }

    if (ipad) {
        os.ios = true;
        os.ipad = true;
        os.version = ipad[2].replace(/_/g, '.');
    }

    if (webos) {
        os.webos = true;
        os.version = webos[2];
    }

    if (touchpad) {
        os.touchpad = true;
    }

    if (blackberry) {
        os.blackberry = true;
        os.version = blackberry[2];
    }

    if (bb10) {
        os.bb10 = true;
        os.version = bb10[2];
    }

    if (rimtabletos) {
        os.rimtabletos = true;
        os.version = rimtabletos[2];
    }

    if (playbook) {
        browser.playbook = true;
    }

    if (kindle) {
        os.kindle = true;
        os.version = kindle[1];
    }

    if (silk) {
        browser.silk = true;
        browser.version = silk[1];
    }

    if (!silk && os.android && ua.match(/Kindle Fire/)) {
        browser.silk = true;
    }

    if (chrome) {
        browser.chrome = true;
        browser.version = chrome[1];
    }

    if (firefox) {
        browser.firefox = true;
        browser.version = firefox[1];
    }

    os.tablet = !!(ipad || playbook || (android && !ua.match(/Mobile/)) ||
    (firefox && ua.match(/Tablet/)));
    os.phone  = !!(!os.tablet && (android || iphone || webos || blackberry || bb10 ||
    (chrome && ua.match(/Android/)) || (chrome && ua.match(/CriOS\/([\d.]+)/)) ||
    (firefox && ua.match(/Mobile/))) || bIsWM);

    return oTemp;
};

var deviceConfig = detect(navigator.userAgent);
device.config = deviceConfig;



if (deviceConfig.os.tablet) {
    device.type = "pad";
}


if (deviceConfig.os.phone) {
    device.type = "mobile";
}

var screenW = win.screen.width;
var screenH = win.screen.height;
var innerW = win.innerWidth;
var innerH = win.innerHeight;


if (deviceConfig.os.ios || device.type === "pc") {
    device.width = screenW;
    device.height = screenH;
} else {
    var ratioW = screenW / innerW;
    var ratioH = screenH / innerH;
    var ratio = ratioW < ratioH ? ratioW : ratioH;
    device.width = Math.floor(screenW / ratio);
    device.height = Math.floor(screenH / ratio);
}




var utils = {
    'containParams': containParams,
    'filterParams': filterParams,
    'getStarTime': getStarTime,
    'getCookie': getCookie,
    'getFrom': getFrom,
    'setCookie' : setCookie,
    'merge' : _merge,
    'containVarParams' : containVarParams,
    'device' : device,
    'getRandomUid' : getRandomUid
};



module.exports = utils;






// WEBPACK FOOTER //
// /Users/zhujian/Desktop/code/live_system/live/modules/f.component.util.pc/index.js